export default __webpack_public_path__ + "static/media/Resume.0d1ca238.png";